// extracted by mini-css-extract-plugin
module.exports = {"footer":"_2fe0aa2","button":"_5ad78a6"};